export default __webpack_public_path__ + "static/media/units_blue_icon.0913ecda.svg";